import { useWizard } from "react-use-wizard";
import sellSteps from "../sellSteps";
import BaseStep from "../../../../../../shared/wizard/steps/baseStep";
import InputNumber from "../../../../../../ui/input/input-number";
import { TKeyOfDataWizardSell, TNumberKeysOfIFillDataWizardSell } from "../..";

interface IKnowPriceStep_8 {
  data: number | null;
  onChange: (data: number, key: TNumberKeysOfIFillDataWizardSell) => void;
  onReset: (key: TKeyOfDataWizardSell[]) => void;
}

const KnowPriceStep_8 = ({ data, onChange, onReset }: IKnowPriceStep_8) => {
  const { goToStep } = useWizard();

  const handlePrevStep = () => {
    goToStep(sellSteps.knowPrice.step_7);
    onReset(["wishPriceSell"]);
  };

  const handleNexStep = () => {
    goToStep(sellSteps.knowPrice.step_9);
  };

  return (
    <div>
      <BaseStep
        prevStep={handlePrevStep}
        nextStep={handleNexStep}
        text="Укажите желаемую стоимость продажи:"
      >
        <InputNumber
          label="Стоимость"
          value={data ? String(data) : undefined}
          onChange={(data) => onChange(Number(data), "wishPriceSell")}
          mode="price"
          placeholder="10 000 000 Р"
        />
      </BaseStep>
    </div>
  );
};

export default KnowPriceStep_8;
